import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';
import { UnidadeAdesaoInterceptor } from './unidade-adesao.interceptor';
import { VersaoAppInterceptor } from './versao-app.interceptor';
import { provideNgxMask } from 'ngx-mask';
import { BrandService } from './services/brand/brand.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideNgxMask(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnidadeAdesaoInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VersaoAppInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (brandService: BrandService) => () => brandService.loadBrand(),
      deps: [BrandService],
      multi: true
    }
  ]
};
